export const TORCH_APPLICATION_FEE = '$250'
export const TORCH_APPLICATION_FEE_CENTS = 25000

export const TORCH_FULL_FILM_APPLICATION_FEE = '$2,500'
